export default __webpack_public_path__ + "static/media/demo_3.b2efff1f.png";